<!-- LandingPage.vue -->
<template>
  <div class="min-h-screen flex items-center justify-center font-inter bg-pitch-black">
    <div class="w-full max-w-sm mx-auto px-6">
      <!-- Logo Section -->
      <div class="text-center mb-4">
        <h1
          class="text-prime-golden text-6xl font-avenir-medium flex justify-center items-center"
        >
          <img
            src="@/assets/images/mason-logo.svg"
            class="w-72 h-72 -my-24"
            alt="Mason Logo"
          />
        </h1>
      </div>

      <!-- Email Input -->
      <div>
        <label class="flex justify-start text-total-white p-1" for="email">Email</label>
        <input
          type="email"
          id="email"
          v-model="email"
          class="w-full p-3 bg-dark-grey rounded-xl mb-6 text-total-white focus:outline-none focus:border-prime-golden"
        />
      </div>

      <!-- Buttons -->
      <div>
        <button
          @click="goToLogin"
          class="w-full bg-prime-golden text-pitch-black p-3 rounded-full mb-4 font-semibold"
        >
          Continue
        </button>
        <button
          @click="goToContact"
          class="w-full bg-dark-grey text-total-white p-3 rounded-full font-semibold"
        >
          Contact us
        </button>
      </div>

      <!-- Footer -->
      <div class="text-center mt-8 text-total-white-500 text-sm">
        <a :href="termsUrl" target="_blank" class="hover:text-prime-golden"
          >Terms of Service</a
        >
        <span class="mx-2">|</span>
        <a :href="privacyUrl" target="https://www.mason.tech/privacy-policy" class="hover:text-prime-golden"
          >Privacy Policy</a
        >
        <p class="mt-4">Copyright 2024 Mason Intelligence, Inc.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
// import { useRouter } from "vue-router";
// import { onMounted } from "vue";

// const router = useRouter();

// onMounted(() => {
//   if (localStorage.getItem('access_token')) {
//     router.push({ name: "ProjectsPage" });
//     return;
//   }
// });

const termsUrl = process.env.VUE_APP_TERMS_URL;
const privacyUrl = process.env.VUE_APP_PRIVACY_POLICY_URL;
</script>

<script>
export default {
  name: "LandingPage",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "", // Add email data property
    };
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: "LogIn", query: { email: this.email } }); // Navigate to login with email as a query parameter
    },
    goToContact() {
      this.$router.push({ name: "Contact", query: { email: this.email } }); // Navigate to contact with email as a query parameter
    },
  },
};
</script>

<style scoped></style>
